
<div class="flex items-center justify-center min-h-full p-4">
  <div class="w-full max-w-md">
    <div class="text-center mb-8">
       <h1 class="text-4xl font-extrabold text-white font-brand tracking-wider">
        <i class="fa-solid fa-leaf mr-2 text-emerald-400"></i>
        CHUAMKAN
      </h1>
      <p class="text-slate-400 mt-2 text-sm font-light uppercase tracking-widest">The Intelligent Clinic OS</p>
    </div>

    <div class="bg-slate-800/80 backdrop-blur-sm shadow-2xl rounded-2xl p-8 border border-slate-700">
      
      @if (isInitializing()) {
        <!-- Loading State: Preparing System -->
        <div class="flex flex-col items-center justify-center py-10 space-y-4">
            <i class="fa-solid fa-circle-notch animate-spin text-4xl text-emerald-500"></i>
            <p class="text-slate-300 text-sm font-semibold">กำลังเตรียมระบบ (Initializing)...</p>
            <p class="text-slate-500 text-xs">Clearing session data for safety</p>
        </div>
      } @else {
        <!-- Ready State: Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="space-y-5">
            <div>
                <label for="email" class="block text-sm font-medium text-slate-300 mb-1">{{ 'login.emailLabel' | translate }}</label>
                <div class="relative">
                <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                    <i class="fa-solid fa-envelope"></i>
                </span>
                <input formControlName="email" id="email" name="email" type="email" autocomplete="email" required
                    class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-3 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600"
                    [class.border-red-500]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    placeholder="name@example.com">
                </div>
                @if(loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
                    <p class="text-red-400 text-xs mt-1">Please enter a valid email address.</p>
                }
            </div>

            <div>
                <label for="password" class="block text-sm font-medium text-slate-300 mb-1">{{ 'login.passwordLabel' | translate }}</label>
                <div class="relative">
                <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                    <i class="fa-solid fa-lock"></i>
                </span>
                <input 
                    [type]="showPassword() ? 'text' : 'password'"
                    formControlName="password" 
                    id="password" 
                    name="password" 
                    autocomplete="current-password" 
                    required
                    class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-10 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600"
                    [class.border-red-500]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                    placeholder="••••••••">
                
                <!-- Toggle Visibility Button -->
               <button 
                type="button" 
                (click)="togglePasswordVisibility()" 
                [attr.aria-label]="showPassword() ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'"
                [attr.title]="showPassword() ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'"
                class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-500 hover:text-slate-300 focus:outline-none">
  
                <i class="fa-solid" [class]="showPassword() ? 'fa-eye-slash' : 'fa-eye'"></i>

            </button>
                </div>
            </div>
            
            <div class="flex items-center justify-between text-sm">
                <label class="flex items-center gap-2 cursor-pointer group">
                    <input type="checkbox" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}" class="w-4 h-4 rounded border-slate-600 bg-slate-700 text-emerald-600 focus:ring-emerald-500">
                    <span class="text-slate-400 group-hover:text-slate-300 transition-colors">Remember me</span>
                </label>
                <a routerLink="/forgot-password" class="text-emerald-400 hover:text-emerald-300 transition-colors">
                    Forgot password?
                </a>
            </div>

            <div>
                <button type="submit" [disabled]="loginForm.invalid || isLoading()"
                class="w-full flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3.5 rounded-lg shadow-lg shadow-emerald-900/20 transition-all transform active:scale-95 disabled:bg-slate-600 disabled:cursor-not-allowed disabled:transform-none">
                @if (isLoading()) {
                    <i class="fa-solid fa-spinner animate-spin"></i>
                    <span>{{ 'login.signingInButton' | translate }}</span>
                } @else {
                    <span>{{ 'login.signInButton' | translate }}</span>
                    <i class="fa-solid fa-arrow-right"></i>
                }
                </button>
            </div>
            </div>
        </form>
      }

    </div>

     <div class="text-center mt-6 flex justify-center items-center gap-4 text-sm">
        <a routerLink="/" class="text-slate-400 hover:text-white transition-colors flex items-center gap-2">
            <div class="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center border border-slate-700">
                <i class="fa-solid fa-keypad text-emerald-400"></i>
            </div>
            {{ 'login.pinLoginLink' | translate }}
        </a>
        <span class="text-slate-600">|</span>
        <a routerLink="/register" class="text-emerald-400 hover:text-emerald-300 transition-colors font-semibold">
            {{ 'login.registerLink' | translate }}
        </a>
    </div>

    <!-- Reset Button -->
    <div class="text-center mt-4">
        <button (click)="resetDeviceData()" class="text-xs text-slate-500 hover:text-red-400 transition-colors underline flex items-center justify-center gap-2 mx-auto">
            <i class="fa-solid fa-rotate-right"></i>
            ล้างข้อมูลเครื่องและเริ่มต้นใหม่ (Reset)
        </button>
    </div>

    <!-- Legal Footer -->
    <div class="mt-8 pt-4 border-t border-slate-800 text-center text-xs text-slate-500">
        <p class="mb-2">© 2026 CHUAMKAN Platform. All rights reserved.</p>
        <div class="flex justify-center gap-4">
            <button (click)="openLegalModal('privacy')" class="hover:text-slate-300 transition-colors">นโยบายความเป็นส่วนตัว</button>
            <span>•</span>
            <button (click)="openLegalModal('tos')" class="hover:text-slate-300 transition-colors">ข้อกำหนดการใช้งาน</button>
        </div>
    </div>
  </div>
</div>

<app-platform-legal-modal
  [isOpen]="isLegalModalOpen()"
  [initialTab]="legalModalTab()"
  (closeModal)="closeLegalModal()">
</app-platform-legal-modal>

<!-- Confirmation Modal -->
<app-confirmation-modal
  [isOpen]="confirmModalState().isOpen"
  [title]="confirmModalState().title"
  [message]="confirmModalState().message"
  [confirmButtonText]="confirmModalState().confirmButtonText"
  [confirmButtonClass]="confirmModalState().confirmButtonClass"
  (confirm)="onConfirmAction()"
  (cancel)="closeConfirmModal()">
</app-confirmation-modal>
